export default {"src":"/_next/static/media/account-details-heading.6430b604.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};